import { selectExternal,insertExternal,updateExternal,deleteExternal,externalBindingCar } from "../../api/config/modules/ExternalEqu";

const state = {
    selectExternal: {},
    insertExternal: {},
    updateExternal: {},
    deleteExternal: {},
    externalBindingCar: {}
};

const mutations = {
  SET_SELECTEXTERNAL: (state, selectExternal) => {
    state.selectExternal = selectExternal;
  },
  SET_INSERTEXTERNAL: (state, insertExternal) => {
    state.insertExternal = insertExternal;
  },
  SET_UPDATEEXTERNAL: (state, updateExternal) => {
    state.updateExternal = updateExternal;
  },
  SET_DELETEEXTERNAL: (state, deleteExternal) => {
    state.deleteExternal = deleteExternal;
  },
  SET_EXTERNALBINDINGCAR: (state, externalBindingCar) => {
    state.externalBindingCar = externalBindingCar;
  },
};

const actions = {
  GET_SELECTEXTERNAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectExternal(data)
        .then((res) => {
          commit("SET_SELECTEXTERNAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTEXTERNAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertExternal(data)
        .then((res) => {
          commit("SET_INSERTEXTERNAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEEXTERNAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateExternal(data)
        .then((res) => {
          commit("SET_UPDATEEXTERNAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEEXTERNAL: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        deleteExternal(data)
        .then((res) => {
          commit("SET_DELETEEXTERNAL", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_EXTERNALBINDINGCAR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        externalBindingCar(data)
        .then((res) => {
          commit("SET_EXTERNALBINDINGCAR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
